/* eslint-disable no-unused-vars,no-prototype-builtins */

import _ from 'lodash';
import {
  START_PAGE_MODE,
  FINISH_PAGE_MODE,
  START_STUDENT_MODE,
  FINISH_STUDENT_MODE,
  START_COMMENT_MODE,
  FINISH_COMMENT_MODE,
  CHANGE_MODE,
  START_STUDENT_PROGRESS_MODE,
  FINISH_STUDENT_PROGRESS_MODE,
  FINISH_COUNTRY_MODE,
  SET_COUNTRY_TOOLTIP,
} from './actions';

export function PageMode(state = {}, action = { type: null }) {
  if (action.type === START_PAGE_MODE) {
    if (Object.keys(state).length !== 0) {
      const newState = _.clone(state);
      return newState;
    }
    const newState = Object.assign({});
    const cohortState = Object.assign({});

    cohortState.hasPageDataLoaded = true;
    cohortState.typeOfMode = 'pages';
    cohortState.pages = [];
    newState[action.cohortPath] = cohortState;

    return newState;
  } else if (action.type === FINISH_PAGE_MODE) {
    const newState = _.clone(state);
    const cohortState = _.clone(action.data);
    cohortState.hasPageDataLoaded = false;
    cohortState.typeOfMode = 'pages';
    newState[action.cohortPath] = cohortState;
    return newState;
  }
  return state;
}

export function ActiveAnalyticsTab(state = 'pages', action = { type: null }) {
  switch (action.type) {
    case START_STUDENT_MODE:
      return 'student';
    case FINISH_STUDENT_MODE:
      return 'student';
    case FINISH_COUNTRY_MODE:
      return 'student';
    case START_COMMENT_MODE:
      return 'comment';
    case FINISH_COMMENT_MODE:
      return 'comment';
    case START_PAGE_MODE:
      return 'page';
    case FINISH_PAGE_MODE:
      return 'page';
    default:
      return 'page';
  }
}

export function changeMode(state = 'pages', action = { type: null }) {
  if (action.type === CHANGE_MODE) {
    return action.state;
  }
  return state;
}

export function StudentMode(state = {}, action = { type: null }) {
  if (action.type === START_STUDENT_MODE) {
    if (Object.keys(state).length !== 0) {
      const newState = _.clone(state);
      return newState;
    }
    const newState = Object.assign({});
    const cohortState = Object.assign({});

    cohortState.hasStudentDataLoaded = true;
    cohortState.hasCountryDataLoaded = true;
    newState.countryTooltip = '';
    cohortState.typeOfMode = 'students';
    cohortState.students = [];
    newState[action.cohortPath] = cohortState;

    return newState;
  } else if (action.type === FINISH_STUDENT_MODE) {
    const newState = _.clone(state);
    const cohortState = _.clone(action.data);

    // Check if previous state has country data
    if (state[action.cohortPath].hasOwnProperty('studentsPerCountry')) {
      cohortState.studentsPerCountry =
        state[action.cohortPath].studentsPerCountry;
    }

    cohortState.hasCountryDataLoaded =
      state[action.cohortPath].hasCountryDataLoaded;
    // Convert students object ot students array.
    const students = [];
    // students.push(['Day', 'Students']);
    _.forOwn(cohortState.students, (value, key) =>
      students.push({ x: new Date(key), y: value })
    );
    // Object.keys(cohortState.students).forEach(key => students.push(key, cohortState.students[key]));
    cohortState.students = students;

    // Output cohort state to the new StudentMode state.
    cohortState.hasStudentDataLoaded = false;
    cohortState.typeOfMode = 'students';
    newState[action.cohortPath] = cohortState;

    return newState;
  } else if (action.type === FINISH_COUNTRY_MODE) {
    const newState = _.clone(state);
    const cohortState = _.clone(action.data);
    // Check if previous state has student data
    if (state[action.cohortPath].hasOwnProperty('students')) {
      cohortState.students = state[action.cohortPath].students;
    }

    cohortState.hasStudentDataLoaded =
      state[action.cohortPath].hasStudentDataLoaded;
    cohortState.hasCountryDataLoaded = false;
    cohortState.typeOfMode = 'students';
    cohortState.studentsPerCountry = action.data.countries;

    newState[action.cohortPath] = cohortState;

    return newState;
  } else if (action.type === SET_COUNTRY_TOOLTIP) {
    const newState = _.clone(state);
    newState.countryTooltip = action.countryTooltip;

    return newState;
  }
  return state;
}

export function StudentProgressMode(state = {}, action = { type: null }) {
  if (action.type === START_STUDENT_PROGRESS_MODE) {
    const newState = Object.assign({});
    newState.hasStudentProgressLoaded = true;
    return newState;
  } else if (action.type === FINISH_STUDENT_PROGRESS_MODE) {
    const newState = _.clone(state);
    const cohortState = _.clone(action.data);

    const result = [];
    _.forOwn(cohortState, (value, key) =>
      result.push({ x: parseInt(key, 10), y: parseInt(value, 10) })
    );
    result.sort((a, b) => a.x - b.x);
    newState.hasStudentProgressLoaded = false;

    newState[action.cohortPath] = result;

    return newState;
  }
  return state;
}

export function CommentMode(state = {}, action = { type: null }) {
  if (action.type === START_COMMENT_MODE) {
    if (Object.keys(state).length !== 0) {
      const newState = _.clone(state);
      return newState;
    }
    const newState = Object.assign({});
    const cohortState = Object.assign({});

    cohortState.hasCommentDataLoaded = true;
    cohortState.typeOfMode = 'comments';
    cohortState.comments = [];
    cohortState.likes = [];
    newState[action.cohortPath] = cohortState;

    return newState;
  } else if (action.type === FINISH_COMMENT_MODE) {
    const newState = _.clone(state);
    const cohortState = _.clone(action.data);

    // Convert students object of comments array.
    const comments = [];
    _.forOwn(cohortState.comments, (value, key) =>
      comments.push({ x: new Date(key), y: value })
    );
    cohortState.comments = comments;

    // Convert students object of likes array.
    const likes = [];
    _.forOwn(action.data.likes, (value, key) =>
      likes.push({ x: new Date(key), y: value })
    );
    cohortState.likes = likes;

    // Output cohort state to the new StudentMode state.
    cohortState.hasCommentDataLoaded = false;
    cohortState.typeOfMode = 'comments';
    newState[action.cohortPath] = cohortState;

    return newState;
  }
  return state;
}
